module.exports = __webpack_public_path__ + "img/poster_5.71f9baca.png";